// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .prompt-right-con{
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
 } 
 .prompt-right-con .header{
   height: 38.5px;
   padding: 0;
   margin: 0;
   display: flex;
   align-items: center;
   gap: 300px;
   background-color:var(--grid-header-color);
   font-weight: bold;
   width: 100%;
   font-size: 14px;
}

 .prompt-right-con .header span:first-child{
   margin-left: 20px;
}

.prompt-right-con .body{
    height:90%;
    width:99%;
    border: 1px solid rgba(47, 46, 46, 0.084);
    margin-top: 5px;
}

.prompt-right-con .btn-con{
    flex-grow: 1;
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/view/prompts/index.css"],"names":[],"mappings":"CAAC;IACG,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;CACtB;CACA;GACE,cAAc;GACd,UAAU;GACV,SAAS;GACT,aAAa;GACb,mBAAmB;GACnB,UAAU;GACV,yCAAyC;GACzC,iBAAiB;GACjB,WAAW;GACX,eAAe;AAClB;;CAEC;GACE,iBAAiB;AACpB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,yCAAyC;IACzC,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf","sourcesContent":[" .prompt-right-con{\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n } \n .prompt-right-con .header{\n   height: 38.5px;\n   padding: 0;\n   margin: 0;\n   display: flex;\n   align-items: center;\n   gap: 300px;\n   background-color:var(--grid-header-color);\n   font-weight: bold;\n   width: 100%;\n   font-size: 14px;\n}\n\n .prompt-right-con .header span:first-child{\n   margin-left: 20px;\n}\n\n.prompt-right-con .body{\n    height:90%;\n    width:99%;\n    border: 1px solid rgba(47, 46, 46, 0.084);\n    margin-top: 5px;\n}\n\n.prompt-right-con .btn-con{\n    flex-grow: 1;\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
